<ng-container *ngIf="termsExists">
  <nb-card>
    <nb-card-header i18n="@SearchSettings">Настройки поиска</nb-card-header>
    <nb-card-body>

      <p>
        <input i18n-placeholder="@@AddManufacturesName" [formControl]="inputFormControl"
               nbInput
               fieldSize="small"
               placeholder="Введите производителя"
               [nbAutocomplete]="auto"
        />
      </p>
      <nb-autocomplete #auto (selectedChange)="insertTerm($event)" [handleDisplayFn]="viewHandle">
        <nb-option *ngFor="let term of terms$ | async" [value]="term">
          {{ term.header }}
        </nb-option>
      </nb-autocomplete>
      <br/><br/>

      <ng-container *ngIf="model.length">
        <nb-list>
          <nb-list-item *ngFor="let term of model | sort: {order: 'asc', key: 'manufactureHeader' }">
            {{ term.manufactureHeader }}&nbsp;
            <input type="number" [(ngModel)]="term.weight" min="1" max="1000" nbInput fieldSize="small">
            <div class="float-end">
              <button i18n-nbTooltip="@@Delete" (click)="removeTerm(term)" nbTooltip="Удалить" nbButton size="small">
                <nb-icon icon="close"/>
              </button>
            </div>
          </nb-list-item>
        </nb-list>


        <ng-container>
          <br/>
          <button type="button" nbButton (click)="saveWeights()" i18n="@@Save">Сохранить</button>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="model.length == 0">
        <p i18n="@@EmptyList">Список пуст</p>
      </ng-container>
    </nb-card-body>
  </nb-card>
</ng-container>
